import {useEffect, useState} from "react";

export const useStarredAdmissionsCount = () => {
  const [count, setCount] = useState(() => {
    const stored = sessionStorage.getItem("totalStarredAdmissions");
    return stored !== null ? parseInt(stored, 10) : 0;
  });

  useEffect(() => {
    const updateCount = () => {
      const stored = sessionStorage.getItem("totalStarredAdmissions");
      setCount(parseInt(stored || "0", 10));
    };

    // Listen for storage events (changes from other tabs/windows)
    window.addEventListener("storage", updateCount);

    // Listen for custom event (changes from same tab)
    window.addEventListener("starredAdmissionsUpdated", updateCount);

    return () => {
      window.removeEventListener("storage", updateCount);
      window.removeEventListener("starredAdmissionsUpdated", updateCount);
    };
  }, []);

  return {
    data: count,
  };
};
